module.exports = __webpack_public_path__ + "img/iosCode.2e7f7234.png";